import { alertTypes } from './types/alert.types';

export const setAlertToJump = (group, alert, index) => {
    return {
        type: alertTypes.SET_ALERT_TO_JUMP,
        payload: {
            group,
            alert,
            index
        }
    };
};

export const clearAlertToJump = () => {
    return {
        type: alertTypes.CLEAR_ALERT_TO_JUMP
    };
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/actions/alert.actions.js